var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CommonDialog',{attrs:{"dialog":_vm.dialog,"head-text":_vm.$t('logout.dialog-title'),"content-text":_vm.$t('logout.dialog-text'),"confirm-button":{
      text: _vm.$t('logout.logout'),
      icon: 'mdi-logout'
    },"on-confirm":_vm.logout,"on-cancel":_vm.goBack}}),_c('BackButton',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"back",attrs:{"defaultRouter":"/"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }